export const LOAD_QUESTIONS_REQUEST = 'questions/LOAD_QUESTIONS_REQUEST';
export const LOAD_QUESTIONS_SUCCESS = 'questions/LOAD_QUESTIONS_SUCCESS';
export const LOAD_QUESTIONS_FAILURE = 'questions/LOAD_QUESTIONS_FAILURE';
export const LOAD_RESPONSES_REQUEST = 'questions/LOAD_RESPONSES_REQUEST';
export const LOAD_RESPONSES_SUCCESS = 'questions/LOAD_RESPONSES_SUCCESS';
export const LOAD_RESPONSES_FAILURE = 'questions/LOAD_RESPONSES_FAILURE';
